import { Badge } from "@arcadeai/design-system/components/ui/atoms/badge";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@arcadeai/design-system/components/ui/atoms/popover";
import { Settings2 } from "lucide-react";
import type { Parameter } from "../types";

type ParametersPopoverProps = {
  parameters: Parameter[];
};

export function ParametersPopover({ parameters }: ParametersPopoverProps) {
  if (parameters.length === 0) {
    return <span className="text-muted-foreground text-sm">None</span>;
  }

  return (
    <Popover>
      <PopoverTrigger
        render={
          <button
            className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-muted-foreground text-sm transition-colors hover:bg-muted hover:text-foreground"
            type="button"
          />
        }
      >
        <Settings2 className="size-3.5" />
        {parameters.length}
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-0">
        <div className="border-b px-3 py-2">
          <h4 className="font-medium text-sm">
            Parameters ({parameters.length})
          </h4>
        </div>
        <div className="max-h-64 overflow-auto">
          {parameters.map((param) => (
            <div
              className="flex items-start gap-3 border-b px-3 py-2 last:border-b-0"
              key={param.name}
            >
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <code className="font-medium font-mono text-sm">
                    {param.name}
                  </code>
                  {param.required ? (
                    <Badge className="text-[10px]" variant="destructive">
                      required
                    </Badge>
                  ) : null}
                </div>
                <div className="mt-0.5 text-muted-foreground text-xs">
                  {param.value_schema.val_type}
                  {param.value_schema.enum ? (
                    <span className="ml-1 text-muted-foreground/70">
                      {`(${param.value_schema.enum.slice(0, 3).join(", ")}${param.value_schema.enum.length > 3 ? "..." : ""})`}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
